import InvoiceManagement from './InvoiceManagement';
export default InvoiceManagement;
